import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    // $(document).ready(function() {
    //   $('input').bind('copy paste cut',function(e) { 
    //   e.preventDefault(); //disable cut,copy,paste
    //   });
    //  });
    
    }
}





// WEBPACK FOOTER //
// D:/Sonali/JCCBViewOnlyProject/ViewOnlyJCCBfrontend19112022/InternetBanking6.3frontend/src/app/home/home.component.ts